<template>
  <v-row class="pb-16 mx-1">
    <v-col><p class="text-h6 py-0 my-0 text-left">Feed</p></v-col>
    <div
      style="height: 200px; overflow: scroll; width: 100%; background: white"
      class="mx-4 py-2 rounded-lg"
    >
      <v-col
        v-for="(item, i) in items.slice().reverse()"
        :key="i"
        cols="12"
        class="py-1"
      >
        <v-card elevation="0" class="rounded-lg chatBg lighten-3">
          <v-card-title
            class="body-2 font-weight-bold"
            v-text="item.field"
          ></v-card-title>
          <v-card-subtitle
            v-text="item.sender"
            class="text-right caption"
          ></v-card-subtitle>
        </v-card>
      </v-col>
    </div>
    <v-col cols="12" class="px-0 py-0">
      <v-card color="transparent" elevation="0">
        <v-card-text>
          <div class="text-h6body-2 font-weight-bold black--text text-left">
            Message
          </div>
          <v-textarea
            class="rounded-lg chatBg lighten-3 pa-1"
            solo
            v-model="dataTextarea"
            name="input-7-4"
            :label="`tulis pesan akhir tahun ${new Date().getFullYear()}...`"
            height="20%"
            hide-details="auto"
          ></v-textarea>
          <!-- <v-card-actions class="mb-10"> -->
          <v-btn
            color="btnPrimary"
            block
            class="py-6 mt-2 white--text"
            @click="sendMsg()"
          >
            Send
          </v-btn>
        </v-card-text>
        <!-- </v-card-actions> -->
      </v-card>
    </v-col>

    <Snackbar
      :active="activeSnackbar"
      :text="pesan"
      @hideSnackbar="hideSnackbar"
    />
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>

<script>
import Snackbar from "../components/Snackbar.vue";
export default {
  components: {
    Snackbar,
  },
  name: "ChatBox",
  data: () => ({
    //snackbar
    activeSnackbar: false,
    pesan: "Message is require",

    dataTextarea: "",
    items: [],
    overlay: false,
    //
  }),
  mounted() {
    this.getMsg();
  },
  methods: {
    KirimPesan() {
      if (this.dataTextarea != "") {
        window.scrollTo(0, 0);
        this.items.push({
          title: this.dataTextarea,
          artist: "USR",
        });
        this.dataTextarea = "";
      } else {
      }
    },
    getMsg() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/chats`)
        .then((response) => {
          const payload = response.data;
          // console.log(payload.data);
          this.items = payload.data;
        });
    },
    hideSnackbar() {
      this.activeSnackbar = false;
    },
    sendMsg() {
      if (this.dataTextarea != "") {
        this.overlay = true;
        // console.log(this.dataTextarea);
        setTimeout(() => {
          this.axios
            .post(`${process.env.VUE_APP_API}/api/chats/post`, {
              sender: this.$store.getters.userInfo.digits,
              field: this.dataTextarea,
              eventTitle: "",
              eventMeetingLink: "",
            })
            .then((response) => {
              const payload = response.data;
              this.getMsg();
            });
          this.activeSnackbar = false;
          this.dataTextarea = "";
          this.overlay = false;
        }, 3000);
      } else {
        this.activeSnackbar = true;
      }
    },
  },
};
</script>
